import React from 'react';
import EmailSetupContainer from '../../Containers/EmailContainer/EmailSetup';


const EmailSetup = (props) => {
	return (
		<EmailSetupContainer />
	);
}

export default EmailSetup;